import { render, staticRenderFns } from "./DemonstrativoFrequenciaDia.vue?vue&type=template&id=566b74d7&"
import script from "./DemonstrativoFrequenciaDia.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoFrequenciaDia.vue?vue&type=script&lang=js&"
import style0 from "./DemonstrativoFrequenciaDia.vue?vue&type=style&index=0&id=566b74d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports